import { createActions, handleActions } from 'redux-actions';

import type {
    IContractToRegistrationActions,
    IContractToRegistrationState,
    IContractToRegistrationStore,
} from './interfaces';
import { getFromStorage } from '@forvalter/utils/storage';
import { localStorageReferences } from './config';

const parsedFilters = getFromStorage<IContractToRegistrationState>(
    localStorageReferences.CONTRACT_REGISTRATION_FILTERS,
);

/* Initial state */
const contractToRegistrationInitialState: IContractToRegistrationState = {
    status: parsedFilters?.status ?? [],
    fromDate: parsedFilters?.fromDate ?? '',
    maxResult: parsedFilters?.maxResult ?? 0,
    selectedKunde: parsedFilters?.selectedKunde ?? '',
};

/* Selectors */
export const contractToRegistrationSelectors = ({
    contractRegistration,
}: IContractToRegistrationStore): IContractToRegistrationState =>
    contractRegistration;

/* Actions */
const contractToRegistrationActions = createActions({
    setStatus: (status: Array<string>) => ({ status }),
    setFromDate: (fromDate: string | null) => ({ fromDate }),
    setMaxResult: (maxResult: number) => ({ maxResult }),
    setSelectedKunde: (selectedKunde: string) => ({ selectedKunde }),
});

export const {
    setStatus,
    setFromDate,
    setMaxResult,
    setSelectedKunde,
}: IContractToRegistrationActions = Object.assign(
    contractToRegistrationActions,
);

/* Reducers */
export const contractToRegistrationReducer = handleActions(
    {
        setStatus: (state, action) => ({
            ...state,
            status: action.payload.status,
        }),
        setFromDate: (state, action) => ({
            ...state,
            fromDate: action.payload.fromDate,
        }),
        setMaxResult: (state, action) => ({
            ...state,
            maxResult: action.payload.maxResult,
        }),
        setSelectedKunde: (state, action) => ({
            ...state,
            selectedKunde: action.payload.selectedKunde,
        }),
    },
    contractToRegistrationInitialState,
);
